import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(getNearbyPopularVenues),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadVenues),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSaga);

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { nearbyPopularVenues } from 'redux/saga/entities/bound';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, put, fork, takeEvery } from 'redux-saga/effects';
import { isAbsent, isEmpty } from 'helpers/verify';
var MAX_VENUES = 20;
var MIN_VENUES = 8;
var MIN_RATING = 4.0;
var RADIUS_ATTEMPTS = [5, 10, 30];
var LOAD_VENUE_DATA = 'cmsPage/modules/VisitableVenues/LOAD_VENUE_DATA';
export var loadVenues = function loadVenues(location) {
  return _objectSpread({
    type: LOAD_VENUE_DATA
  }, location);
};
export var nearbyVenuesKey = function nearbyVenuesKey(location) {
  return location && "venues-near-".concat(location.lat, "-").concat(location.lon);
};
export function filterValidVenues(venues) {
  try {
    return venues.filter(function (_ref) {
      var _ref$ratings = _ref.ratings,
          total = _ref$ratings.count.total,
          mean = _ref$ratings.mean;
      return mean >= MIN_RATING || total === 0;
    });
  } catch (error) {
    return [];
  }
}
export function getNearbyPopularVenues(client, location, radii) {
  var key, _radii, _radii2, radius, nextRadii, _ref2, venues, validVenueCount;

  return regeneratorRuntime.wrap(function getNearbyPopularVenues$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (isAbsent(radii)) {
            radii = RADIUS_ATTEMPTS;
          }

          key = nearbyVenuesKey(location);
          _radii = radii, _radii2 = _toArray(_radii), radius = _radii2[0], nextRadii = _radii2.slice(1);

          if (!isAbsent(radius)) {
            _context.next = 5;
            break;
          }

          return _context.abrupt("return");

        case 5:
          _context.next = 7;
          return call(fetchEntityIfNeeded, nearbyPopularVenues, [client, 0, {
            lat: location.lat,
            lon: location.lon,
            page_size: MAX_VENUES,
            page: 0,
            radius: radius
          }], {
            key: key
          });

        case 7:
          _ref2 = _context.sent;
          venues = _ref2.venues;
          validVenueCount = filterValidVenues(venues).length;

          if (!(validVenueCount < MIN_VENUES && !isEmpty(nextRadii))) {
            _context.next = 15;
            break;
          }

          _context.next = 13;
          return put(nearbyPopularVenues.resetAction({
            key: key
          }));

        case 13:
          _context.next = 15;
          return call(getNearbyPopularVenues, client, location, nextRadii);

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doLoadVenues(client, _ref3) {
  var lat, lon;
  return regeneratorRuntime.wrap(function doLoadVenues$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          lat = _ref3.lat, lon = _ref3.lon;
          _context2.prev = 1;

          if (![lat, lon].some(isAbsent)) {
            _context2.next = 4;
            break;
          }

          return _context2.abrupt("return");

        case 4:
          _context2.next = 6;
          return call(getNearbyPopularVenues, client, {
            lat: lat,
            lon: lon
          });

        case 6:
          _context2.next = 10;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](1);

        case 10:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 8]]);
}
export function watchSaga(client) {
  return regeneratorRuntime.wrap(function watchSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, loadVenues().type, doLoadVenues, client);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}